import React from "react";
import ReactDOM from "react-dom/client";
// Применяем исправления локализации ПЕРЕД всем остальным
import "./utils/localePolyfill";
import "./index.css";
import App from "@/App";

// Disable error overlay completely
if (process.env.NODE_ENV === 'development') {
  // Disable React error overlay
  const noop = () => {};
  
  // Override error handling
  window.addEventListener('error', (e) => {
    e.stopImmediatePropagation();
  }, true);
  
  window.addEventListener('unhandledrejection', (e) => {
    e.stopImmediatePropagation();
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
